import _ from 'lodash';

import { updateItemInList, addItemToList } from 'utils/reducer-utils';
import { mergeUpdateFromServer } from 'utils/socket-utils';
import { UPDATE, UPDATE_ONE } from './action-types';


export default function layout(state = {}, action) {
  const newState = _.assign({}, state);

  switch (action.type) {
    case UPDATE:
      newState[action.key] = action.data;
      break;
    case UPDATE_ONE:
      // Update the item in the list
      newState[action.key] = updateItemInList(newState[action.key], action.updatedItem.id, (itemToUpdate) =>
        mergeUpdateFromServer(itemToUpdate, action.updatedItem)
      );
      // If the updated item is new, add it to the array and re-sort
      if (!_.find(newState[action.key], { id: action.updatedItem.id })) {
        newState[action.key] = addItemToList(newState[action.key], action.updatedItem, action.sortBy);
      }
      // If the updated item was archived, remove it from the list. We never want to show archived items
      if (action.updatedItem.status === 'Archived') newState[action.key] = _.reject(newState[action.key], { id: action.updatedItem.id });
      break;
    default:
      return state;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./app/modules/page-data/reducers.js